import { render, staticRenderFns } from "./DashboardsView.vue?vue&type=template&id=eb6ee3f6&scoped=true"
import script from "./DashboardsView.vue?vue&type=script&lang=js"
export * from "./DashboardsView.vue?vue&type=script&lang=js"
import style0 from "./DashboardsView.vue?vue&type=style&index=0&id=eb6ee3f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6ee3f6",
  null
  
)

export default component.exports